import { render, staticRenderFns } from "./ActiveSuppliers.vue?vue&type=template&id=29128414&"
import script from "./ActiveSuppliers.vue?vue&type=script&lang=js&"
export * from "./ActiveSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports